import { AuthenticationContext, AdalConfig } from 'react-adal'

import { Config } from './config'

export const { adalConfig } = Config

export const authContext = new AuthenticationContext(adalConfig as AdalConfig)

export const DO_NOT_LOGIN = process.env.NODE_ENV === 'development'
